(function () {
  "use strict";

  var cache = {};

  function fetchBadgeHtml(handle) {
    if (cache[handle] !== undefined) {
      return Promise.resolve(cache[handle]);
    }
    return fetch("/products/" + handle + "?view=deal-badge", {
      headers: { Accept: "text/html" },
    })
      .then(function (r) {
        return r.ok ? r.text() : "";
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var wrapper = doc.getElementById("shopify-section-deal-badge");
        var content = wrapper ? wrapper.innerHTML.trim() : "";
        cache[handle] = content;
        return content;
      })
      .catch(function () {
        cache[handle] = "";
        return "";
      });
  }

  function injectBadge(card) {
    if (card.dataset.dealBadgeInjected) return;
    card.dataset.dealBadgeInjected = "true";

    var handle = card.getAttribute("swatch-generated");
    if (!handle) return;

    var badgeContainer = card.querySelector(
      ".Product_card_gallery_limited_all_new",
    );
    if (!badgeContainer) return;

    if (badgeContainer.innerHTML.trim() !== "") return;

    fetchBadgeHtml(handle).then(function (html) {
      if (html) badgeContainer.innerHTML = html;
    });
  }

  function processAllCards(root) {
    var cards = root.querySelectorAll("product-card[swatch-generated]");
    cards.forEach(injectBadge);
  }

  function observeWidget(widgetEl) {
    processAllCards(widgetEl);

    var observer = new MutationObserver(function (mutations) {
      var shouldProcess = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          shouldProcess = true;
          if (node.matches && node.matches("product-card[swatch-generated]")) {
            injectBadge(node);
          }
        });
        if (
          mutation.type === "attributes" &&
          mutation.target.tagName === "PRODUCT-CARD"
        ) {
          shouldProcess = true;
        }
      });
      if (shouldProcess) {
        processAllCards(widgetEl);
      }
    });

    observer.observe(widgetEl, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["swatch-generated"],
    });
  }

  function init() {
    var existing = document.querySelectorAll("[data-rebuy-id]");
    existing.forEach(observeWidget);

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var widgets = node.querySelectorAll
            ? node.querySelectorAll("[data-rebuy-id]")
            : [];
          if (node.dataset && node.dataset.rebuyId) {
            observeWidget(node);
          }
          Array.from(widgets).forEach(function (w) {
            observeWidget(w);
          });
        });
      });
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
